import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";
import { WebcamInitError, WebcamImage } from 'ngx-webcam';

@Injectable({
  providedIn: 'root'
})
export class HeadshotUploadService {
  showTips = true

  constructor() { }

  headshotState: HeadshotUploadState = {
    retake: false,
    showWebcam: false,
    errors: [],
    webcamImage: new BehaviorSubject<WebcamImage | null>(null),
    trigger: new Subject<void>(),
    headshot_uploading: false,
    headshot_upload_error: '',
    valid_headshot: false,
  };

  getState(): HeadshotUploadState {
    return this.headshotState;
  }

  handleInitError(error: WebcamInitError): void {
    this.headshotState.errors.push(error);
  }

  retakePhoto() {
    this.toggleWebcam();
    this.headshotState.retake = true;
    this.headshotState.webcamImage.next(null);
  }

  toggleWebcam(): void {
    this.headshotState.showWebcam = !this.headshotState.showWebcam;
  }

  handleImage(webcamImage: WebcamImage): void {
    this.headshotState.webcamImage.next(webcamImage);
    this.toggleWebcam();
    this.headshotState.retake = false;
  }

  triggerSnapshot(): void {
    this.headshotState.trigger.next();
  }

  resetHeadshot() {
    this.showTips = true;
    this.headshotState = {
      retake: false,
      showWebcam: false,
      errors: [],
      webcamImage: new BehaviorSubject<WebcamImage | null>(null),
      trigger: new Subject<void>(),
      headshot_uploading: false,
      headshot_upload_error: '',
      valid_headshot: false,
    };
  }

}

export interface HeadshotUploadState {
  retake: boolean;
  showWebcam: boolean;
  errors: WebcamInitError[];
  webcamImage: BehaviorSubject<WebcamImage | null>;
  trigger: Subject<void>;
  headshot_uploading: boolean;
  headshot_upload_error: string;
  valid_headshot: boolean;
}
